<button class="btn btn--more" modal-close-btn tabindex="0" title="Sluit">
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs">
        <use href="assets/icons-ui.svg#cross-closed"></use>
    </svg>
</button>
<h2 modal-title>
    Wijziging doorgevoerd
</h2>


<div class="modal-body" modal-content>
    <p *ngIf="products && products.length > 0">
        Heel goed dat u dit aan ons doorgeeft. Uw premie wordt daardoor:
    </p>

    <p *ngIf="products && products.length === 0">
       Goed dat u dit aan ons doorgeeft. Uw premie blijft gewoon hetzelfde.
    </p>
    <table *ngIf="products && products.length > 0" class="table premium-impact">
        <colgroup>
            <col>
            <col width="100">
            <col width="100">
        </colgroup>
        <thead>
        <tr>
            <td>&nbsp;</td>
            <th class="text-before">van:</th>
            <th class="text-after">naar:</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let product of products">
            <tr>
                <td>
                    <h3 class="text-capitalize">{{ product.product_description }}</h3>
                    <p class="small">{{ product.reference }}</p>
                </td>
                <th class="text-before">{{ product.premium_current | number:'1.2-2' }}</th>
                <th class="text-after">{{ product.premium_reference_date | number:'1.2-2' }}</th>
            </tr>
        </ng-container>
        </tbody>
    </table>
</div>

<div class="btn-group btn-group--right">
    <button (click)="confirm()" class="btn btn--primary" type="button">OK</button>
</div>
